import { gql } from '@apollo/client'

/**
 * Query: appConfig
 * Get application configuration (API keys) from backend
 * Used for runtime configuration without rebuilding frontend
 */
export const APP_CONFIG = gql`
  query appConfig {
    appConfig {
      googleMapsApiKey
      recaptchaSiteKey
    }
  }
`

/**
 * Query: configHealth
 * Check configuration health status
 */
export const CONFIG_HEALTH = gql`
  query configHealth {
    configHealth {
      status
      checks {
        googleMapsApiKey
        recaptchaSiteKey
      }
    }
  }
`
